module dg.objects {


    export class PeriodDisplayerController extends PropertyDisplayerControllerBase<dg.domain.model.Period> {
        public constructor(
            private $filter: ng.IFilterService,
            private periodService: PeriodService
        ) {
            super();
            this.periodOptions = periodService.getPeriodOptions;
        }

        public periodOptions: any;
        public formattedValue: string;

        $onChanges = (changes) => {
            if (changes.value.previousValue !== changes.value.currentValue) {
                let period = this.periodService.convertToClient(this.value);
                this.formattedValue = this.periodService.stringifyValue(period);
            }
        }
    }

    dg.objects.AngularHelper.registerPropertyDisplayer(PeriodDisplayerController, 'periodDisplayer', {
        template: '<span ng-bind="$ctrl.formattedValue"></span>'
    });


    //angular.module('dg.objects')
    //    .component('periodDisplayer', {
    //        bindings: {
    //            value: '<'
    //        },
    //        controller: PeriodDisplayerController,
    //        template: '<span ng-bind="$ctrl.formattedValue"></span>',
    //    });
}
